<template>
  <section id="templates">
    <description>Ein Template ist eine Art Schablone, die festlegt, wie die Inhalte angezeigt werden. Von jedem Template können später im Content Management System mehrere Seiten angelegt werden. Jedes Ihrer individuellen Screendesigns benötigt ein entsprechendes Template in Ihrer Konfiguration.</description>
    <hint :condition="showHint">Sie müssen mindestens ein Template hinzufügen.</hint>
    <section id="structure-builder" ref="sb"> <!--  :class="{ 'dragging' : dragging }" -->
      <section id="selection"> <!-- v-bind:style="scrollStyle" -->
        <draggable class="draggable-items" tag="ul" :list="selection" :group="{ name: 'g1', pull: 'clone', put: false }" :clone="cloneItem" :sort="false" :forceFallback="true" @start="dragStart()" @end="dragEnd()">
          <li v-for="element in selection" :key="element.key" class="draggable-item" :class="{'disabled-item' : element.invisible}" :ref="element.id">
            <img :src="getImgUrl(element.icon)" :alt="element.name" />
            <span>{{ element.name }}</span>
          </li>
        </draggable>
      </section>
      <section id="collection">
        <nested :items="collection" @start="dragStart" @end="dragEnd" @deleted-item="resetVisibility(selection)"></nested>
      </section>
    </section>
    <aside id="structure-builder-hint">
      <p>Wählen Sie die Templates aus, die wir nach Ihren Designvorgaben programmieren sollen.</p>
    </aside>
    <section id="infobox">
      <div id="infoheader" @click="showInfo = !showInfo">
        <h2>Wie sind die Templates zu verstehen?</h2>
        <button v-if="!showInfo" class="backend-button less-button">anzeigen</button>
        <button v-else class="backend-button more-button">ausblenden</button>
      </div>
      <div v-if="showInfo" id="infocontent">
        <p>Jedes Ihrer individuellen Screendesigns benötigt ein entsprechendes Template in Ihrer Konfiguration. Besitzt die geplante Website bestimmte Funktionen wie einen Shop oder einen Blog, müssen die jeweiligen Templates gewählt werden.</p>
        <h3>Page-Template</h3>
        <p>Vorlagen für den anzuzeigenden Inhalt. Zum Beispiel für eine Startseite, eine "Über uns"-Seite oder für eine "Team"-Seite. Mit diesen Page-Templates können später im CMS mehrere Seiten angelegt werden. Haben Sie also beispielsweise ein Screendesign für eine individuelle Startseite und ein Screendesign für eine Inhaltsseite, benötigen Sie zwei Page-Templates.</p>
        <h3>Blog</h3>
        <p>Der Bereich, in dem Posts in einem Newsfeed angezeigt werden. Ob für einen Blog im klassischen Sinne oder einen "News-Bereich" einer Firmenwebsite.</p>
        <h3>Shop</h3>
        <p>Templates und Infrastruktur im CMS für einen vollständigen Online-Shop. So können Produkte zum Verkauf eingefügt werden. Weitere Shop-Funktionen werden im späteren Verlauf konfiguriert.</p>
        <h3>Suche</h3>
        <p>Templates und Funktion für eine individuelle Volltextsuche auf der Website.</p>
      </div>
    </section>
    <controller next="/sprachen" next-text="Nächster Schritt" prev="/" :check="!nothingCollected" @falseClick="falseClick()" />
    <inclusive-footer />
    <how-to />
    <made />
  </section>
</template>

<script>
import Controller from '@/components/Controller.vue'
import Description from '@/components/Description.vue'
import Hint from '@/components/Hint.vue'
import HowTo from '@/components/HowTo.vue'
import InclusiveFooter from '@/components/InclusiveFooter.vue'
import draggable from 'vuedraggable'
import nested from '@/components/Nested.vue'
import Made from '@/components/Made.vue'
let keyGlobal = 6
export default {
  name: 'Templates',
  components: {
    Description,
    Hint,
    Controller,
    HowTo,
    InclusiveFooter,
    draggable,
    nested,
    Made
  },
  data: function () {
    return {
      showHint: false,
      showInfo: false,
      selection: [
        { name: 'Page-Template', icon: 'landingpage', key: 1, id: 1, items: [], invisible: false, unique: false },
        {
          name: 'Blog',
          icon: 'blog',
          key: 2,
          id: 2,
          items: [],
          children: [
            { name: 'Artikelseiten', key: 1 },
            { name: 'Autorenseiten', key: 2 }
          ],
          invisible: false,
          unique: true
        },
        {
          name: 'Shop',
          icon: 'onlineshop',
          key: 3,
          id: 3,
          items: [],
          children: [
            { name: 'Produktseiten', key: 1 },
            { name: 'Warenkorb', key: 2 },
            { name: 'Login', key: 3 },
            { name: 'Account', key: 4 },
            { name: 'Kasse', key: 5 }
          ],
          invisible: false,
          unique: true
        },
        {
          name: 'Suche',
          icon: 'seo',
          key: 4,
          id: 4,
          items: [],
          children: [
            { name: 'Suchergebnisse', key: 1 }
          ],
          invisible: false,
          unique: true
        }
      ]
    }
  },
  computed: {
    collection: function () {
      return this.$root.collection
    },
    onlineshop: function () {
      return this.$root.items.find(item => item.id === 'onlineshop').status
    },
    blogfunktion: function () {
      return this.$root.items.find(item => item.id === 'blogfunktion').status
    },
    nothingCollected: function () {
      if (this.collection.length === 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    falseClick: function () {
      this.showHint = true
    },
    getImgUrl: function (icon) {
      var images = require.context('../assets/img/icons/items/', false, /\.svg$/)
      return images('./' + icon + '.svg')
    },
    cloneItem: function (original) {
      return {
        key: keyGlobal++,
        name: original.name,
        icon: original.icon,
        id: original.id,
        children: original.children,
        invisible: original.invisible,
        unique: original.unique,
        items: []
      }
    },
    dragStart: function () {
      this.$refs.sb.className = 'dragging'
      // console.log(this.$refs.sb)
      // this.dragging = true
    },
    dragEnd: function () {
      this.$refs.sb.className = ''
      // this.dragging = false
    },
    resetVisibility: function (toReset) {
      for (let item of toReset) {
        item.invisible = false
        if (item.items.length > 0) {
          this.resetVisibility(item.items)
        }
      }
      this.setSelectionVisibility(this.collection)
    },
    setSelectionVisibility: function (checkThis) {
      for (let item of checkThis) {
        if (item.unique) {
          // console.log(this.$refs[item.id])
          // this.$refs[item.id][0].hidden = true
          // this.$refs[item.id][0].disabled = true
          this.selection.find(selectionItem => selectionItem.id === item.id).invisible = true
        }
        if (item.items.length > 0) {
          this.setSelectionVisibility(item.items)
        }
      }
    },
    countPages: function (toCount) {
      let numberOfPages = 0
      for (let item of toCount) {
        if (item.items.length > 0) { // if has children
          numberOfPages += this.countPages(item.items) // recursive call
        }
        if (item.name === 'Page-Template') {
          numberOfPages++
        }
      }
      return numberOfPages
    },
    hasPage: function (searchIn, find) {
      for (let item of searchIn) {
        if (item.name === find) {
          return true
        }
        if (item.items.length > 0) {
          if (this.hasPage(item.items, find)) {
            return this.hasPage(item.items, find)
          }
        }
      }
      return false
    },
    convertToItemSelection: function (toConvert) {
      // set pages
      this.$root.items.find(item => item.id === 'pages').amount = this.countPages(toConvert)
      if (this.countPages(toConvert) > 0) {
        this.$root.items.find(item => item.id === 'pages').status = true
      } else {
        this.$root.items.find(item => item.id === 'pages').status = false
      }
      // set blog
      this.$root.items.find(item => item.id === 'blogfunktion').status = this.hasPage(toConvert, 'Blog')
      // set shop
      this.$root.items.find(item => item.id === 'onlineshop').status = this.hasPage(toConvert, 'Shop')
      // set search
      this.$root.items.find(item => item.id === 'suchfunktion').status = this.hasPage(toConvert, 'Suche')
    }
  },
  mounted: function () {
    this.setSelectionVisibility(this.collection)
  },
  watch: {
    nothingCollected: function (value) {
      if (!value) {
        this.showHint = false
      }
    },
    collection: {
      deep: true,
      handler: function (list) {
        this.setSelectionVisibility(list)
        this.convertToItemSelection(list)
      }
    },
    blogfunktion: function (val) {
      if (!val) {
        this.$root.items.find(item => item.id === 'kommentare').status = false
        this.$root.items.find(item => item.id === 'videoposts').status = false
        this.$root.items.find(item => item.id === 'share').status = false
      }
    },
    onlineshop: function (val) {
      if (!val) {
        this.$root.items.find(item => item.id === 'produktoptionen').status = false
        this.$root.items.find(item => item.id === 'produktfilter').status = false
        this.$root.items.find(item => item.id === 'downloadprodukte').status = false
        this.$root.items.find(item => item.id === 'sociallogin').status = false
        this.$root.items.find(item => item.id === 'affiliate').status = false
        this.$root.items.find(item => item.id === 'paymentmethods').status = false
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/css/variables.scss";
img {
  pointer-events: none!important;
}
.sortable-fallback {
  opacity: 1!important;
}
#structure-builder {
  user-select: none;
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  margin: 30px 0 10px 0;
  img {
    border-radius: 6px;
    width: 26px;
    height: auto;
    margin-right: 8px;
  }
  #selection {
    flex-grow: inherit;
    width: 100%;
    .draggable-items {
      display: flex;
      flex-direction: row;
      padding: 0;
      height: 100%;
      flex-wrap: wrap;
    }
    .draggable-item {
      display: flex;
      align-items: center;
      line-height: 1;
      list-style: none;
      background: #fff;
      margin: 0 5px 5px 0;
      padding: 12px 12px;
      border-radius: 8px;
      box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
      transition: opacity 0.2s;
      &:hover {
        cursor: grab;
      }
      &:active,
      &:focus {
        cursor: grabbing!important;
      }
      &.draggable-item.disabled-item {
        display: none;
        transition: 0.2s;
        opacity: 0.4;
        box-shadow: none;
      }
    }
  }
  #collection {
    display: flex;
    border: 4px dashed #d3d3d3;
    flex-grow: 4;
    transition: border-color 0.2s ease-in-out;
    .collection-items {
      padding: 30px 20px;
      // padding: 0;
      width: 100%;
      margin: 0;
      position: relative;
      &:first-child {
        &:before {
          z-index: 1;
          opacity: 0;
          width: 100%;
          text-align: center;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          content: 'Templates hierhin ziehen';
          transition: 0.1s;
          color: $secondaryFontColor;
        }
      }
      &.no-items {
        &:first-child {
          &:before {
            opacity: 1;
          }
        }
      }
      .draggable-item {
        list-style: none;
        margin: 0 0 10px 0;
        position: relative;
        z-index: 2;
        &:hover {
          cursor: grab;
        }
        &:active {
          cursor: grabbing;
        }
        .collection-items {
          width: auto;
          margin: 10px 0 0 45px;
          padding: 0;
          box-sizing: border-box;
          // border: 2px dashed #d3d3d3;
          min-height: 0;
          // padding: 10px 10px;
          transition: padding 0.1s ease-in-out, min-height 0.1s ease-in-out;
        }
        span,
        .item-children {
          button.delete-item {
            width: 16px;
            height: 24px;
            background-image: url('../assets/img/icons/trash.svg');
            background-repeat: no-repeat;
            background-size: 12px 20px;
            background-position: center;
            opacity: 0.7;
            transition: 0.2s;
            &:hover {
              opacity: 1;
            }
          }
          display: flex;
          justify-content: left;
          padding: 12px 14px 12px 12px;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
          line-height: 1;
          align-items: center;
          .delete-item {
            border: none;
            outline: 0;
            margin-left: auto;
            -webkit-appearance: none;
            -moz-appearance: none;
            background: #fff;
            background: transparent;
          }
        }
        .item-children  {
          padding: 12px 20px;
          margin-top: 10px;
          margin-left: 5px;
        }
      }
    }
  }
  &.dragging {
    #collection {
      &:hover {
        cursor: grabbing!important;
      }
      border: 4px dashed #607BFF;
      .collection-items {
        .draggable-item {
          &:hover {
            cursor: grabbing!important;
          }
          &.sortable-ghost {
            opacity: 0!important;
            .collection-items {
              border: none;
              padding: 0;
              min-height: 0;
            }
          }
          .collection-items {
            margin: 10px 0 40px 45px;
            border: 2px dashed #d3d3d3;
            min-height: 40px;
            padding: 10px 10px;
          }
          &.sortable-fallback {
            .collection-items {
              border: none;
              padding: 0;
              min-height: 0;
              height: 0;
            }
          }
        }
      }
    }
  }
}
#structure-builder-hint {
  color: $secondaryFontColor;
  font-size: 14px;
  padding: 0 15px 20px 15px;
}
.sortable-chosen {
  line-height: 1;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.06);
  &.draggable-item-collected {
    padding: 0;
    box-shadow: none;
    padding: 0;
    background: transparent;
  }
}
#infobox {
  #infoheader {
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:hover {
      cursor: pointer;
    }
    .backend-button {
      @include backend-button();
    }
  }
  #infocontent {
    border-top: 1px solid #dedede;
    padding: 20px;
  }
  margin: 0 15px 0 15px;
  padding: 0;
  background: #fff;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  h2 {
    margin: 0;
    font-size: 22px;
  }
  h2,
  h3 {
    font-family: $primaryFont;
    font-weight: $primaryFontBold;
    color: $primaryFontColor;
  }
  h3 {
    margin-bottom: 6px;
    margin-top: 20px;
  }
}
#templates {
  padding-top: 80px;
  padding-bottom: 0;
}
@media (min-height: 420px) {
  #templates {
    padding-bottom: 107px;
  }
}
@media (min-height: 520px) {
  #templates {
    padding-bottom: 127px;
  }
}
@media(min-width:767px) {
  #infobox {
    margin: 0 40px 0 40px;
  }
  #templates {
    padding-top: 100px;
    #structure-builder {
      img {
        width: 34px;
      }
      padding: 0 40px;
      flex-direction: row;
      margin: 50px 0 20px 0;
      #selection {
        width: 240px;
        .draggable-items {
          margin: 0 20px 0 0;
          flex-direction: column;
          flex-wrap: nowrap;
          .draggable-item {
            margin: 0 0 10px 0;
          }
        }
      }
    }
    #structure-builder-hint {
      padding: 0 15px 40px 280px;
    }
  }
}
</style>
